import ComponentType from "@/enums/ComponentType";
import FieldType from "@/enums/FieldType";

const Heading = {
  type: ComponentType.TEXT,
  name: "text",
  settings: {
    text: {
      type: FieldType.TEXT
    }
  }
};

export default Heading;